import * as React from 'react';
import { createPortal } from 'react-dom';
import './HelpIconButton.scss';

interface Props {
  onClick: () => void;
  label?: string;
  title?: string;
  className?: string;
  text?: string;
  iconSrc?: string;
}

export function HelpIconButton({
  onClick,
  label = 'How this page works',
  title = label,
  className = '',
  text,
  iconSrc
}: Props): React.ReactElement | null {
  const [headerTarget, setHeaderTarget] = React.useState<HTMLElement | null>(null);

  React.useEffect(() => {
    setHeaderTarget(document.getElementById('sit-topbar-help-slot'));
  }, []);

  const button = (
    <button
      type="button"
      className={`sitHelpIconButton${text ? ' sitHelpIconButton--withText' : ''}${className ? ` ${className}` : ''}`}
      onClick={onClick}
      aria-label={label}
      title={title}
    >
      {iconSrc ? (
        <img className="sitHelpIconButton__icon" src={iconSrc} alt="" aria-hidden="true" />
      ) : (
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <circle cx="12" cy="12" r="8.5" />
          <path d="M9.8 9.35a2.35 2.35 0 0 1 4.48 1c0 1.75-2.28 2.05-2.28 3.65" />
          <path d="M12 17.25h.01" />
        </svg>
      )}
      {text && <span className="sitHelpIconButton__text">{text}</span>}
    </button>
  );

  return headerTarget ? createPortal(button, headerTarget) : null;
}
